<template>
<div @click="selectContact(contact)">
    <div class="contact-inner">
        <div class="avatar">
            <img :src="getImage" alt="user" class="img-responsive">
            <span v-show="hasUnreadMessages">{{ contact.unread }}</span>
        </div>
        <div class="info">
            <h3>{{ contact.name }}</h3>
            <h4 class="uppercase">{{ contact.type }}</h4>
        </div>
        <div class="on-time">{{ last_message }}</div>
    </div>
</div>
</template>

<script>
export default {
    props: ['contact'],

    data() {
        return {
            selected: false,
            messagesRead: this.hasUnreadMessages,
        }
    },

    mounted() {
    },

    methods: {
        selectContact(contact){
            setTimeout(() => {
                this.$parent.selectedContact = contact;
            },300);            
        }
    },

    computed: {
        hasUnreadMessages() {
            if (this.messagesRead) {
                return false;
            }
            return this.contact.unread > 0;
        },

        getImage(){
            return this.contact.image ? App.restApi + '/api/image/' + this.contact.image : '/img/web/default-avatar.svg';
        },

        last_message(){
            if ( !this.contact.last_message_timestamp ) return "NO MESSAGES";
            var offset = moment.duration(moment().add(3,'seconds').diff(this.contact.last_message_timestamp* 1000))._data;

            if (offset.months > 1) return offset.months + " months";
            if (offset.days > 1) return offset.days  + " days";
            if (offset.hours) return offset.hours + "h";
            if (offset.minutes) return offset.minutes + "m";
            return offset.seconds + "s";
        }
    },
}
</script>